import { Component, Host, h, Listen } from '@stencil/core';

@Component({
  tag: 'bam-subnavigation',
  styleUrl: 'bam-subnavigation.scss',
  shadow: false,
})
export class BamSubNavigation {

  @Listen('balNavigate')
  handleLinkClick(e){
    let dataLayerObject = {
      event: 'component',
      componentId: 'sub-navigation',
      componentStyle: 'no-style',
      componentTopic: e.target.label,
      componentActionArea: 'content',
      componentContext: 'navigation'
    };
    window.dataLayer.push(dataLayerObject);
  }

  render() {
    return (
      <Host>
        <slot></slot>
      </Host>
    );
  }

}